var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"verofresh"},[_c('router-view'),_c('maintenance-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }